// WeeklyProfit.jsx
import React from 'react';

// redux
import withShipment from "../../../withShipment";
import { userInfoSelector } from "../../../redux/selectors/auth";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";

import CustomToolbar from "../../global/CustomToolbar";

import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PieChartIcon from '@material-ui/icons/PieChart';

import './WeeklyProfit.css';

import {
  Grid,
  Paper,
  TextField,
  Button,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  CardContent,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, IconButton, Checkbox,
} from "@material-ui/core";
import { format, addDays } from 'date-fns';
import {FormControlLabel, ToggleButton, ToggleButtonGroup, Tooltip} from "@mui/material";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {AddHome} from "@mui/icons-material";
import axios from "axios";
import {BASE_URL} from "../../global/Server/endpoints";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import FeedbackBar from "../../feedbackBar/FeedbackBar";


class WeeklyProfit extends React.Component {
  constructor(props) {
    super(props);


    const savedFrom = localStorage.getItem('weeklyProfitFromDate');
    const savedTo = localStorage.getItem('weeklyProfitToDate');

    let fromDate, toDate;

    if (savedFrom && savedTo) {
      fromDate = new Date(savedFrom);
      toDate = new Date(savedTo);
    } else {
      // Fallback to current week calculation (Tuesday -> Monday)
      const today = new Date();
      const currentDay = today.getDay();
      const diffToLastTuesday = currentDay >= 2 ? currentDay - 2 : 7 - (2 - currentDay);
      fromDate = new Date(today);
      fromDate.setDate(today.getDate() - diffToLastTuesday);
      toDate = new Date(fromDate);
      toDate.setDate(fromDate.getDate() + 6);
    }

    this.state = {
      locations: [],
      weeklyProfits: [],
      adjustments: [],
      addProfitOpen: false,
      addLocationOpen: false,
      addInvestorOpen: false,
      addInvestorLocationId: null,
      selectedLocationId: null,
      profitForm: { locationId: '', date: new Date(), netProfit: '' },
      locationForm: { name: '', investors: [] },
      investorForm: { id: '', name: '', percentage: '', profitThreshold:'',   isManager: false },
      searchQuery: '',
      viewMode: 'profits',
      fromDate,
      toDate,
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
      editingInvestor: false,

      deleteInvestorDialogOpen: false,
      deleteInvestorTarget: null,

      deleteLocationDialogOpen: false,
      deleteLocationTarget: null,
      renameLocationOpen: false,
      renameLocationForm: { locationId: '', name: '' },

    };
  }


  async componentDidMount() {
    await this.fetchLocations();
    this.applyDateRange();
  }

  getToken = () => localStorage.getItem("token");

  fetchLocations = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/location/list`, {
        headers: { Authorization: `Bearer ${this.getToken()}` }
      });
      if (res.data.success) {
        this.setState({ locations: res.data.locations });
      } else {
        this.openFeedback("error", "Failed to fetch locations");
      }
    } catch (err) {
      this.openFeedback("error", `Failed to fetch locations: ${err.message}`);
    }
  };

  saveLocationAPI = async () => {
    const { locationForm } = this.state;
    if (!locationForm.name) return alert('Provide location name');
    try {
      const res = await axios.post(`${BASE_URL}/location/saveLocation`, locationForm, {
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          "Content-Type": "application/json"
        }
      });
      if (res.data.success) {
        this.setState(prev => ({
          locations: [...prev.locations, res.data.location],
          addLocationOpen: false,
          locationForm: { name: '' }
        }));
      } else {
        this.openFeedback("error", res.data.message);
      }
    } catch (err) {
      this.openFeedback("error", `Failed to add location: ${err.message}`);
    }
  };

  saveInvestorAPI = async () => {
    const { addInvestorLocationId, investorForm } = this.state;
    if (!investorForm.name || investorForm.percentage === '' || addInvestorLocationId === null) return alert('Provide name & percentage');

    try {
      if (investorForm.investorId) {
        // update investor
        const payload = {
          investorId: investorForm.investorId,
          name: investorForm.name,
          percentage: Number(investorForm.percentage),
          profitThreshold: Number(investorForm.profitThreshold),
          isManager: investorForm.isManager

        };
        const res = await axios.post(`${BASE_URL}/location/updateInvestor`, payload, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
            "Content-Type": "application/json"
          }
        });
        if (res.data.success) {
          // update investor in locations state
          this.setState(prev => ({
            locations: prev.locations.map(loc => {
              if (loc.locationId === addInvestorLocationId) {
                return {
                  ...loc,
                  investors: loc.investors.map(inv => {
                    const invId = inv.investorId;
                    if (invId === investorForm.investorId) {
                      return res.data.investor;
                    }
                    return inv;
                  })
                };
              }
              return loc;
            }),
            addInvestorOpen: false,
            addInvestorLocationId: null,
            investorForm: { id: '', name: '', percentage: '', profitThreshold: '', isManager: false },
            editingInvestor: false
          }));
        } else {
          this.openFeedback("error", res.data.message);
        }
      } else {
        // create investor
        const payload = {
          locationId: addInvestorLocationId,
          name: investorForm.name,
          percentage: Number(investorForm.percentage),
          profitThreshold: Number(investorForm.profitThreshold),
          isManager: investorForm.isManager
        };
        const res = await axios.post(`${BASE_URL}/location/saveInvestor`, payload, {
          headers: {
            Authorization: `Bearer ${this.getToken()}`,
            "Content-Type": "application/json"
          }
        });
        if (res.data.success) {
          // update state
          this.setState(prev => ({
            locations: prev.locations.map(loc => {
              if (loc.locationId === addInvestorLocationId) {
                return { ...loc, investors: [...(loc.investors||[]), res.data.investor] };
              }
              return loc;
            }),
            addInvestorOpen: false,
            addInvestorLocationId: null,
            investorForm: { id: '', name: '', percentage: '', profitThreshold: '' }
          }));
        } else {
          this.openFeedback("error", res.data.message);
        }
      }
      this.applyDateRange();
    } catch (err) {
      this.openFeedback("error", `Failed to save investor: ${err.message}`);
    }
  };

  deleteInvestorAPI = async (locationId, investor) => {
    const invId = investor.investorId;
    if (!invId) return this.openFeedback("error", "Investor id missing");
    try {
      const res = await axios.post(`${BASE_URL}/location/deleteInvestor`, { investorId: invId }, {
        headers: { Authorization: `Bearer ${this.getToken()}` }
      });
      if (res.data.success) {
        // remove investor from locations state
        this.setState(prev => ({
          locations: prev.locations.map(loc => {
            if (loc.locationId === locationId) {
              return { ...loc, investors: (loc.investors || []).filter(inv => (inv.investorId || inv.investorId) !== invId) };
            }
            return loc;
          })
        }));
        this.openFeedback("info", "Investor deleted");
      } else {
        this.openFeedback("error", res.data.message);
      }
    } catch (err) {
      this.openFeedback("error", `Failed to delete investor: ${err.message}`);
    }
  };

  saveRenameLocationAPI = async () => {
    const { renameLocationForm } = this.state;
    if (!renameLocationForm.name.trim()) return;

    try {
      const payload = { locationId: renameLocationForm.locationId, name: renameLocationForm.name.trim() };
      const res = await axios.post(`${BASE_URL}/location/renameLocation`, payload, {
        headers: { Authorization: `Bearer ${this.getToken()}`, "Content-Type": "application/json" }
      });
      if (res.data.success) {
        this.setState(prev => ({
          locations: prev.locations.map(l =>
              l.locationId === renameLocationForm.locationId
                  ? { ...l, name: res.data.location.name || renameLocationForm.name }
                  : l
          ),
          renameLocationOpen: false,
          renameLocationForm: { locationId: '', name: '' }
        }));
        this.openFeedback("info", "Location renamed");
      } else {
        this.openFeedback("error", res.data.message);
      }

      this.applyDateRange()
    } catch (err) {
      this.openFeedback("error", `Failed to rename location: ${err.message}`);
    }
  };


  deleteLocationApi = async (locationId) => {
    try {
      const res = await axios.post(`${BASE_URL}/location/deleteLocation`, { locationId: locationId}, {
        headers: { Authorization: `Bearer ${this.getToken()}`, "Content-Type": "application/json" }
      });
      if (res.data.success) {
        this.setState(prev => ({
          locations: prev.locations.filter(l => l.locationId !== locationId),
          weeklyProfits: prev.weeklyProfits.filter(wp => wp.locationId !== locationId)
        }));
        this.openFeedback("info", "Location deleted");
      } else {
        this.openFeedback("error", res.data.message);
      }
    } catch (err) {
      this.openFeedback("error", `Failed to delete location: ${err.message}`);
    }
  };

  // opens the Add Investor dialog in edit mode for a specific investor
  openEditInvestor = (locationId, investor) => {
    this.setState({
      addInvestorOpen: true,
      addInvestorLocationId: locationId,
      editingInvestor: true,
      investorForm: {
        investorId: investor.investorId,
        name: investor.name || '',
        percentage: investor.percentage ?? '',
        profitThreshold: investor.profitThreshold ?? '',
        isManager: investor.isManager
      }
    });
  };

  openRenameLocationDialog = (loc) => {
    this.setState({
      renameLocationOpen: true,
      renameLocationForm: { locationId: loc.locationId, name: loc.name || '' },
    });
  };

  closeRenameLocationDialog = () => {
    this.setState({ renameLocationOpen: false, renameLocationForm: { locationId: '', name: '' } });
  };

  openDeleteInvestorDialog = (locationId, investor) => {
    this.setState({
      deleteInvestorDialogOpen: true,
      deleteInvestorTarget: { locationId, investor },
    });
  };

  closeDeleteInvestorDialog = () => {
    this.setState({
      deleteInvestorDialogOpen: false,
      deleteInvestorTarget: null,
    });
  };

  openDeleteLocationDialog = (loc) => {
    this.setState({
      deleteLocationDialogOpen: true,
      deleteLocationTarget: { locationId: loc.locationId, name: loc.name},
    });
  };

  closeDeleteLocationDialog = () => {
    this.setState({
      deleteLocationDialogOpen: false,
      deleteLocationTarget: null,
    });
  };

  // Tuesday check
  isTuesday = (date) => date.getDay() === 2;

  // Get Monday after the given Tuesday
  getMondayFromTuesday = (tuesdayDate) => {
    const monday = new Date(tuesdayDate);
    monday.setDate(tuesdayDate.getDate() + 6);
    return monday;
  };


  handleFromDateChange = (date) => {
    if (!date || !this.isTuesday(date)) return;

    const toDate = this.getMondayFromTuesday(date);
    this.setState({
      fromDate: date,
      toDate,
    }, () => {
      // Save to localStorage
      localStorage.setItem('weeklyProfitFromDate', date.toISOString());
      localStorage.setItem('weeklyProfitToDate', toDate.toISOString());
    });
  };

  handleToDateChange = (date) => {
    if (!date) return;

    const { fromDate } = this.state;
    if (!fromDate) return;

    const validMonday = this.getMondayFromTuesday(fromDate);
    if (date.toDateString() !== validMonday.toDateString()) return;

    this.setState({ toDate: date }, () => {
      // Save to localStorage
      localStorage.setItem('weeklyProfitFromDate', fromDate.toISOString());
      localStorage.setItem('weeklyProfitToDate', date.toISOString());
    });
  };


  getLocation = id => this.state.locations.find(l => l.locationId === id);

  /* --- Dialog handlers --- */
  openAddProfit = () => this.setState({ addProfitOpen: true, profitForm: { locationId: this.state.locations[0]?.locationId || '', date: new Date(), netProfit: '' } });

  closeAddProfit = () => this.setState({ addProfitOpen: false });

  saveProfit = () => {
    const { profitForm, weeklyProfits } = this.state;
    if (!profitForm.locationId || !profitForm.netProfit) return alert('Provide location and profit');
    const newRow = { id: weeklyProfits.length ? Math.max(...weeklyProfits.map(r => r.locationId)) + 1 : 1, ...profitForm, netProfit: Number(profitForm.netProfit) };
    this.setState(prev => ({ weeklyProfits: [newRow, ...prev.weeklyProfits], addProfitOpen: false }));
  }

  openAddLocation = () => this.setState({ addLocationOpen: true, locationForm: { name: '', investors: [] } });
  closeAddLocation = () => this.setState({ addLocationOpen: false });


  openAddInvestor = (locationId) => this.setState({ addInvestorOpen: true, addInvestorLocationId: locationId, investorForm: { id: '', name: '', percentage: '', profitThreshold:'',   isManager: false } });
  closeAddInvestor = () => this.setState({ addInvestorOpen: false, addInvestorLocationId: null });


  openLocationInvestorSplit = (locationId) =>
      this.setState({
        selectedLocationId: locationId,
      });

  handleBackClick = () => {
    this.setState({ selectedLocationId: null});
  };

  handleToggle = (event, newValue) => {
    if (newValue) this.setState({ viewMode: newValue, selectedLocationId: null, });
  }


  applyDateRange = async () => {
    const { fromDate, toDate, locations } = this.state;
    if (!locations.length) return;

    const from = format(fromDate, 'yyyy-MM-dd');
    const to = format(toDate, 'yyyy-MM-dd');

    try {
      const res = await axios.post(
          `${BASE_URL}/lizAccounting/locationSummary`,
          {
            fromDate: from,
            toDate: to,
            locations: locations.map(l => l.name)
          },
          {
            headers: { Authorization: `Bearer ${this.getToken()}` }
          }
      );

      if (!res.data.success) {
        this.openFeedback("error", "Failed to fetch weekly profits");
        return;
      }

      const weeklyProfits = res.data.sessions
          .map(session => {
            const loc = locations.find(
                l => l.name.toUpperCase() === session.locationName.toUpperCase()
            );
            if (!loc) return null;

            const netProfit = session.managerSummary?.weeklyNetProfit || 0;

            // ---- Separate managers & owners ----
            const managers = (loc.investors || []).filter(i => i.isManager === true);
            const owners = (loc.investors || []).filter(i => !i.isManager);

            // ---- Manager deductions (FROM GROSS PROFIT FIRST) ----
            let totalManagerShare = 0;

            const managerShares = managers.map(m => {
              const threshold = Number(m.profitThreshold) || 0;

             const profitAboveThreshold = Math.max(0, netProfit - threshold);

               const share = (profitAboveThreshold * (Number(m.percentage) || 0)) / 100;

              // Eligible if no threshold OR profit >= threshold
             // const eligible = threshold === 0 || netProfit >= threshold;

              // const share = eligible
              //     ? (netProfit * (Number(m.percentage) || 0)) / 100
              //     : 0;

              totalManagerShare += share;

              return {
                investorId: m.investorId,
                share: Number(share.toFixed(2))
              };
            });

            // ---- Remaining profit for owners ----
            const remainingProfit = Math.max(0, netProfit - totalManagerShare);

            // ---- Normalize owner percentages ----
            const totalOwnerPct = owners.reduce(
                (sum, o) => sum + (Number(o.percentage) || 0),
                0
            );

            return {
              id: session.readingSessionId,
              locationId: loc.locationId,
              date: new Date(fromDate),
              netProfit,
              investors: loc.investors.map(inv => {
                // ---- Manager ----
                if (inv.isManager === true) {
                  const found = managerShares.find(
                      m => m.investorId === inv.investorId
                  );

                  return {
                    ...inv,
                    share: found ? found.share : 0
                  };
                }

                // ---- Owner ----
                const normalizedPct = totalOwnerPct
                    ? (Number(inv.percentage) || 0) / totalOwnerPct
                    : 0;

                return {
                  ...inv,
                  share: Number(
                      (remainingProfit * normalizedPct).toFixed(2)
                  )
                };
              })
            };
          })
          .filter(Boolean);

      this.setState({ weeklyProfits });
    } catch (err) {
      this.openFeedback(
          "error",
          `Failed to fetch weekly profits: ${err.message}`
      );
    }
  };


  computeInvestorSummary = (investorId, locationId = null) => {
    const { weeklyProfits, fromDate, toDate } = this.state;


    // Filter profits for the selected location and week range
    const relevantProfits = weeklyProfits.filter(p =>
        p.locationId === locationId &&
        new Date(p.date) >= new Date(fromDate) &&
        new Date(p.date) <= new Date(toDate)
    );

    if (relevantProfits.length === 0) return { finalBalance: 0 };

    // API gives one entry per location per week, so pick the first
    const profitWeek = relevantProfits[0];

    // Find investor share
    const investor = profitWeek.investors.find(i => i.investorId === investorId);

    return {
      totalProfit: investor ? investor.share : 0,
      finalBalance: investor ? investor.share : 0,
      breakdown: profitWeek.investors || []
    };
  };

  openFeedback = (severity, message) => {
    this.setState({
      feedbackBarOpen: true,
      feedbackStatus: severity,
      feedbackMessage: message,
    });
  };

  closeFeedbackBar = () => {
    this.setState({ feedbackBarOpen: false });
  };

  render() {
    const { locations, weeklyProfits, searchQuery, viewMode, addProfitOpen, addLocationOpen, addInvestorOpen,
      investorForm, selectedLocationId, profitForm, locationForm, fromDate, toDate} = this.state;

    const filteredProfits = weeklyProfits.filter(p => {
      const loc = this.getLocation(p.locationId);
      const q = searchQuery.toLowerCase();
      return !q || loc?.name.toLowerCase().includes(q) || format(p.date, 'MMMM d, yyyy').toLowerCase().includes(q);
    });

    const selectedLocation = selectedLocationId ? this.getLocation(selectedLocationId) : null;


    const validMonday = fromDate ? this.getMondayFromTuesday(fromDate) : null;

    const headerButtons = selectedLocation
        ? [
          {
            icon: <KeyboardBackspaceIcon />,
            handler: () => this.handleBackClick(),
            title: "Back",
          },
        ]
        : [
          ...(viewMode === 'profits'
              ? [
                {
                  icon: <AddCircleIcon />,
                  handler: this.openAddProfit,
                  title: "Add Profit",
                },
              ]
              : []),
          ...(viewMode === 'investorSplit'
              ? [
                {
                  icon: <AddHome />,
                  handler: this.openAddLocation,
                  title: "Add Location",
                },
              ]
              : []),
        ];

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    severity={this.state.feedbackStatus}
                    message={this.state.feedbackMessage}
                    handleClose={this.closeFeedbackBar}
                />
        <CustomToolbar
          title="Profits"
          createTitle="WeeklyProfit"
          backTitle="Back To Menu"
          headerButtons={headerButtons}
        />

        {/* Toggle */}
        <div className="toggle-navbar">
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={this.handleToggle}
            className="toggle-container"
          >
            <ToggleButton value="profits" className="toggle-button">
              <AttachMoneyIcon className="toggle-icon" />
              <span className="toggle-text">Profits</span>
            </ToggleButton>

            <ToggleButton value="investorSplit" className="toggle-button">
              <PieChartIcon className="toggle-icon" />
              <span className="toggle-text">Investor Split</span>
            </ToggleButton>
          </ToggleButtonGroup>
        </div>

        <div className="root">
          {viewMode === 'profits' ? (
            <>

              <div className="date-range">
                <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="From Date"
                    format="yyyy-MM-dd"
                    value={fromDate}
                    onChange={this.handleFromDateChange}
                    shouldDisableDate={(date) => !this.isTuesday(date)}
                    disableMaskedInput
                />

                <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="To Date"
                    format="yyyy-MM-dd"
                    value={toDate}
                    onChange={this.handleToDateChange}
                    shouldDisableDate={(date) => {
                      if (!validMonday) return true;
                      return date.toDateString() !== validMonday.toDateString();
                    }}
                    disableMaskedInput
                />

                <Button
                    variant="contained"
                    onClick={this.applyDateRange}
                    color="primary"
                    style={{
                      width: '100px',
                      height:'55px',
                      marginRight: '16px',
                      marginBottom: '16px',
                    }}
                >
                  Apply
                </Button>
              </div>

              {!selectedLocation ? (
                <Grid container spacing={2}>
                  {filteredProfits.map((p) => {
                    const loc = this.getLocation(p.locationId);
                    const weekStart = format(p.date, 'MMM d');
                    const weekEnd = format(addDays(p.date, 6), 'MMM d');
                    return (
                      <Grid item xs={12} sm={6} md={4} key={p.locationId}>
                        <Card
                          className="profitCard"
                          onClick={() => this.openLocationInvestorSplit(p.locationId, p.date)}
                        >
                          <CardContent>
                            <h5 className="profitTitle">{loc?.name}</h5>
                            <Typography className="profitWeek">
                              {weekStart} - {weekEnd}
                            </Typography>
                            <Typography className="profitAmount">
                              ${p.netProfit.toLocaleString()}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              ) : (
                  <Paper className="investorTable">
                    <Typography variant="h6" style={{marginBottom: 12}}>
                      {selectedLocation?.name} - Investor Splits
                    </Typography>

                    {/* Investors Table */}
                    <div className="responsiveTableWrapper">
                      <Table className="responsiveTable">
                        <TableHead>
                          <TableRow>
                            <TableCell style={{fontWeight: 700}}>
                              Investor
                            </TableCell>
                            <TableCell align="right" style={{fontWeight: 700}}>
                              %
                            </TableCell>
                            <TableCell align="right" style={{fontWeight: 700}}>
                              Profit Share
                            </TableCell>
                            <TableCell align="center" style={{fontWeight: 700}}>
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedLocation?.investors.map((inv) => {
                            const summary = this.computeInvestorSummary(inv.investorId, selectedLocationId);

                            return (
                                <TableRow key={inv.investorId}>
                                  <TableCell>{inv.name}</TableCell>
                                  <TableCell align="right">{inv.percentage}</TableCell>
                                  <TableCell align="right">
                                    ${summary.finalBalance.toLocaleString()}
                                  </TableCell>
                                  <TableCell align="center">
                                    <Tooltip title="Edit Investor">
                                      <IconButton size="small"
                                                  onClick={() => this.openEditInvestor(selectedLocationId, inv)}>
                                        <EditIcon fontSize="small"/>
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Delete Investor">
                                      <IconButton size="small"
                                                  onClick={() => this.openDeleteInvestorDialog(selectedLocationId, inv)}>
                                        <DeleteIcon fontSize="small"/>
                                      </IconButton>
                                    </Tooltip>

                                  </TableCell>
                                </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>

                  </Paper>
                )}
            </>
          ) :  (
            <Grid container>
              <Grid item xs={12}>
                <Paper className="investorTable">
                  <Typography variant="h6" style={{ marginBottom: 12 }}>
                    Investor Splits
                  </Typography>

                  <div className="responsiveTableWrapper">
                    <Table className="responsiveTable">
                      <TableHead>
                        <TableRow>
                          <TableCell className="tableCellHeader">#</TableCell>
                          <TableCell className="tableCellHeader">
                            Location
                          </TableCell>
                          {Array.from(
                            new Set(
                              locations.flatMap((l) =>
                                l.investors.map((i) => i.name)
                              )
                            )
                          ).map((name, idx) => (
                            <TableCell
                              key={idx}
                              align="center"
                              className="tableCellHeader"
                            >
                              {name} %
                            </TableCell>


                          ))}
                          <TableCell className="tableCellHeader" align="center">
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {locations.map((loc, idx) => (
                          <TableRow key={loc.locationId}>
                            <TableCell>{idx + 1}</TableCell>
                            <TableCell style={{ fontWeight: 700 }}>
                              {loc.name}
                            </TableCell>
                            {Array.from(
                              new Set(
                                locations.flatMap((l) =>
                                  l.investors.map((i) => i.name)
                                )
                              )
                            ).map((invName, idx2) => {
                              const found = loc.investors.find(
                                (i) => i.name === invName
                              );
                              return (
                                <TableCell key={idx2} align="center">
                                  {found ? found.percentage.toFixed(2) : '-'}
                                </TableCell>
                              );
                            })}
                            <TableCell align="center">
                              <Tooltip title="Add Investor">
                                <IconButton
                                    size="small"
                                    onClick={() => this.openAddInvestor(loc.locationId)}
                                >
                                  <PersonAddIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Rename Location">
                                <IconButton
                                    size="small"
                                    onClick={() => this.openRenameLocationDialog(loc)}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title="Delete Location">
                                <IconButton
                                    size="small"
                                    onClick={() => this.openDeleteLocationDialog(loc)}
                                    color="error"
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </Paper>
              </Grid>
            </Grid>
          )}


          {/* Add Profit Dialog */}
          <Dialog
            open={addProfitOpen}
            onClose={this.closeAddProfit}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Add Profit</DialogTitle>
            <DialogContent dividers>
              <TextField
                select
                label="Location"
                fullWidth
                margin="dense"
                variant="outlined"
                value={profitForm.locationId}
                onChange={(e) =>
                  this.setState({
                    profitForm: {
                      ...profitForm,
                      locationId: Number(e.target.value),
                    },
                  })
                }
              >
                {locations.map((l) => (
                  <MenuItem key={l.locationId} value={l.locationId}>
                    {l.name}
                  </MenuItem>
                ))}
              </TextField>

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                {/* Date Picker */}
                <KeyboardDatePicker
                    style={{marginTop:'16px',marginBottom:'8px'}}
                    className='input-text-field'
                    autoOk
                    fullWidth
                    name="weekStartDate"
                    label="Week Start Date"
                    variant="inline"
                    inputVariant="outlined"
                    format="MM/dd/yyyy"
                    InputAdornmentProps={{position: 'start'}}
                    onChange={(date) =>
                        this.setState({ profitForm: { ...profitForm, date } })
                    }
                    value={profitForm.date}
                />
              </MuiPickersUtilsProvider>

              <TextField
                label="Net Profit"
                type="number"
                fullWidth
                margin="dense"
                variant="outlined"
                value={profitForm.netProfit}
                onChange={(e) =>
                  this.setState({
                    profitForm: { ...profitForm, netProfit: e.target.value },
                  })
                }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeAddProfit} variant="outlined">
                Cancel
              </Button>
              <Button
                onClick={this.saveProfit}
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>


          {/* Add Location Dialog */}
          <Dialog
              open={addLocationOpen}
              onClose={this.closeAddLocation}
              maxWidth="sm"
              fullWidth
          >
            <DialogTitle>Add Location</DialogTitle>
            <DialogContent dividers>
              <TextField
                  label="Location Name"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={locationForm.name}
                  onChange={(e) =>
                      this.setState({
                        locationForm: { ...locationForm, name: e.target.value },
                      })
                  }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeAddLocation} variant="outlined">
                Cancel
              </Button>
              <Button
                  onClick={this.saveLocationAPI}
                  variant="contained"
                  color="primary"
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
              open={this.state.renameLocationOpen}
              onClose={this.closeRenameLocationDialog}
              maxWidth="sm"
              fullWidth
          >
            <DialogTitle>Rename Location</DialogTitle>
            <DialogContent dividers>
              <TextField
                  label="Location Name"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={this.state.renameLocationForm.name}
                  onChange={(e) =>
                      this.setState({
                        renameLocationForm: { ...this.state.renameLocationForm, name: e.target.value },
                      })
                  }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeRenameLocationDialog} variant="outlined">
                Cancel
              </Button>
              <Button
                  onClick={this.saveRenameLocationAPI}
                  variant="contained"
                  color="primary"
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>


          {/* Add/Edit Investor Dialog */}
          <Dialog
              open={addInvestorOpen}
              onClose={this.closeAddInvestor}
              maxWidth="sm"
              fullWidth
          >
            <DialogTitle>{this.state.editingInvestor ? 'Edit Investor' : 'Add Investor'}</DialogTitle>
            <DialogContent dividers>
              <TextField
                  label="Investor Name"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={investorForm.name}
                  onChange={(e) =>
                      this.setState({
                        investorForm: { ...investorForm, name: e.target.value },
                      })
                  }
              />
              <TextField
                  label="Percentage (%)"
                  type="number"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  value={investorForm.percentage}
                  onChange={(e) =>
                      this.setState({
                        investorForm: {
                          ...investorForm,
                          percentage: e.target.value,
                        },
                      })
                  }
              />


              <FormControlLabel
                  control={
                    <Checkbox
                        checked={investorForm.isManager}
                        onChange={(e) =>
                            this.setState({
                              investorForm: {
                                ...investorForm,
                                isManager: e.target.checked,
                                profitThreshold: e.target.checked
                                    ? investorForm.profitThreshold
                                    : ''
                              }
                            })
                        }
                        color="primary"
                    />
                  }
                  label="Manager"
              />

              {investorForm.isManager && (
                  <TextField
                      label="Profit Threshold"
                      type="number"
                      fullWidth
                      margin="dense"
                      variant="outlined"
                      value={investorForm.profitThreshold}
                      onChange={(e) =>
                          this.setState({
                            investorForm: {
                              ...investorForm,
                              profitThreshold: e.target.value
                            }
                          })
                      }
                  />
              )}


            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeAddInvestor} variant="outlined">
                Cancel
              </Button>
              <Button
                  onClick={this.saveInvestorAPI}
                  variant="contained"
                  color="primary"
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>


          <Dialog
              open={this.state.deleteInvestorDialogOpen}
              onClose={this.closeDeleteInvestorDialog}
              maxWidth="xs"
              fullWidth
          >
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent dividers>
              <Typography>
                Are you sure you want to delete investor "{this.state.deleteInvestorTarget?.investor.name}"
              </Typography>
            </DialogContent>
            <DialogActions style={{marginBottom:'16px', marginRight:'16px', marginTop:'16px'}}>
              <Button onClick={this.closeDeleteInvestorDialog} variant="outlined">
                Cancel
              </Button>
              <Button
                  onClick={() => {
                    const { locationId, investor } = this.state.deleteInvestorTarget;
                    this.deleteInvestorAPI(locationId, investor);
                    this.closeDeleteInvestorDialog();
                  }}
                  variant="contained"
                  color="primary"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>


          <Dialog
              open={this.state.deleteLocationDialogOpen}
              onClose={this.closeDeleteLocationDialog}
              maxWidth="xs"
              fullWidth
          >
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent dividers>
              <Typography>
                Are you sure you want to delete location "{this.state.deleteLocationTarget?.name}"
              </Typography>
            </DialogContent>
            <DialogActions style={{marginBottom:'16px', marginRight:'16px', marginTop:'16px'}}>
              <Button onClick={this.closeDeleteLocationDialog} variant="outlined">
                Cancel
              </Button>
              <Button
                  onClick={() => {
                    const { locationId } = this.state.deleteLocationTarget;
                    this.deleteLocationApi(locationId);
                    this.closeDeleteLocationDialog();
                  }}
                  variant="contained"
                  color="primary"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>


        </div>
      </MuiPickersUtilsProvider>
    );
  }
}

const mapStateToProps = state => ({userInfo: userInfoSelector(state)});


export default withShipment({
  mapStateToProps,
}, WeeklyProfit);
